<template>
    <div id="app" ref="app" data-route="Motif" :class="[ {'loading' : this.$store.state.loadingStatus.length}, this.$store.state.productInfo.productName.replace(' ', '-').toLowerCase()]">


        <div id="npHeader">
            <div>
                <a title="Custom Needlepoint | Needlepaint" id="hdrNavLogoLink" v-on:click="leaveActive=true">
                    <img v-if="this.productLocation()==1" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAS1BMVEVIoq3///83nKg9nqr1+frR5OdlrbalzNFCoKswmqZ9uMD7/P2hytDG3uLn8fLf7O5TprCWxMt1tL2u0Na+2d6Mv8a21dpcqbTu9PYbEep2AAACuElEQVRoge2Y2XKDMAxFLQmDzB6y8f9fWllAAw1JIbVn+sB9ajrkoEhXtmVjDh06dOjQoX8lZhQRx0C7+/VibZV1SKHZmFoYlZwwbPR4Fmp9ycpbU8gf99/p29/vJOymIyRC12bynvR9ahg5bzeysQIo3RQLtj0U7bvI6C7BdNti5xzghLPPJoH+Tej+eSg2wrGByi2+3RbQvKRzK1VJNxad75Lj70eVyR2AdS+elyT2m/3EV+gnELdnzQ9dAW4v6FRAvrkVKHtEyclYKCylxrj2uPzQYit6CScLzYDEG6wHyCkk2+GLtHSQjOl0L+y2Ey4FnVpy/k1qoFhp1X3wuRX9r5hyQZL2hJ/oO+Hkm0jpTD1cpjKSXwee7b4Tru1/JlnM0xrg4fgM6uLZ7nvhBqV4hbW17+rvUAVeSTNdftB3w9XWXnZWQbWo/D9b2n0/3JDLy+zUuln9PBydLPTXBf0DuC8mLYuncOOqH3b/CP6kAe6NCnO7B4UbsWcy29XCwrlNoI4FN5TOV/fAcG3h770qNNzgSVoYI8H1XDPaPTxc7T7sHRHganfdxmPADdaD3aPA1e4UCa52b1wkuCFZ3SuMBB/s7iLBjZNt9dRGgqvdT7HgelR6gvPzAeQjuLf7Es7O5Pnd7cSvw/1kUMz2Dmp1Uqu71VPrG61Gw/diOqwabSmAvoflbPK5WO0+fpA9sO+IdwxJvwgfk4GMR5ojlkLXr0aRnfRyygJPZ3t/VA4TunEyGVz96s6lX270hQ2UgeZ6f7j0q7vP/zjnVHKWDQM3rh4GYbQVTa8LBjdGbKJeHX0jtrkGu4/QQfjhD79ghkKboX3sdPWD3ePsEUR+EK5TR/6q47w24PxJ6C8Y6lt29quLDX19pVcjqmJ92v6TGNuysvaWh78XG/kuzo3eoUOHDh069F/1Ba1iF8qSQ8yPAAAAAElFTkSuQmCC"
                         alt="Needlepaint" />
                    <img v-else src="//brewsterbelt.myshopify.com/cdn/shop/files/Brewster_standard_1.png?v=1707854127&width=280" alt="Brewster Designer" />
                </a>
                <!-- <h2 v-if="this.$route.name == 'Size'"> Needlepoint {{ this.$store.state.productInfo.productName }} Builder</h2>-->
                <!--<div  v-if="this.$route.name == 'Size'" class="header-info">
                <a class="button"  v-on:click="goRoute('motifs')">Next</a>
            </div>-->
                <div class="header-info" v-if="this.$route.name == 'Design'">

                    <Finish></Finish>

                </div>
            </div>
        </div>
        <header>
            <ProductPreview @open-custom-motif="openCustomMotif"
                            @open-background="openBackground" v-if="this.$route.name != 'Size'" />
            <transition name="fade">
                <div v-show="this.$store.state.loadingStatus.length" class="loading-status">
                    <label>{{ this.$store.state.loadingStatus }}</label>
                    <div class="loader"></div>
                </div>
            </transition>
        </header>

        <!--<router-view v-slot="{ Component }">
        <transition :name="slide">
            <component :is="Component" />
        </transition>
    </router-view>-->

        <div id="stepContainer">
            <transition :name="'slide-fade-' + routeDirection">
                <router-view class="view"
                             @open-custom-motif="openCustomMotif"
                             @alert-width="alertWidth" />
            </transition>
        </div>
        <transition name="anim-fade-in">
            <CustomMotif v-if="customizingMotif"
                         :pm="customizingProductMotif"
                         :motif="customizingMotif"
                         @reset-customizing-motif="resetCustomizingMotif"
                         @add-custom-motif="addCustomMotif"
                         @edit-custom-motif="editCustomMotif"
                         @alert-width="alertWidth" />
        </transition>
        <!--<footer>

        <div id="nav" ref="nav">
            <router-link to="/">Size</router-link>
            <router-link to="/motifs">Design</router-link>
            <router-link to="/finish">Finish</router-link>
        </div>
    </footer>-->
        <!--<h3>JSON object data</h3>
    <pre id="jsonDisplay">
        {{ productInfoJson
                }}
                </pre>-->
        <div v-if="leaveActive" class="alert popup">
            <div class="popup-content">
                <div class="close"
                     @click="
            leaveActive = false;
          "></div>
                <p>If you have made changes in the designer, they will not be saved if you leave.</p>
                <a @click="leaveActive = false;" class="button ">Keep Designing</a><br />
                <a onclick="document.getElementById('btnFinish').click()" @click="leaveActive = false;" class="button secondary">Save Changes &amp; Finish</a><br />
                <a :href="rootUrl()" class="button secondary">Leave Without Saving</a>
            </div>
            <div class="overlay"
                 @click="
          leaveActive = false;
        "></div>
        </div>



        <div v-if="alertWidthActive == true" class="alert popup">
            <div class="popup-content">
                <div class="close"
                     @click="
            alertWidthActive = false;
            alertWidthMotif = null;
          "></div>
                <div v-if="alertWidthMotif">
                    <p>There is not room for this motif.</p>
                    <img class="motif"
                         :title="this.alertWidthMotif.motifName"
                         :src="
              this.alertWidthMotif.motifImageData
                ? 'data:image/png;base64,' + this.alertWidthMotif.motifImageData
                : this.alertWidthMotif.motifUrl
            " /><br /><br />

                    <p>Please remove motif(s) and try again.</p>
                </div>
                <div v-else>
                    Your selected motifs will not fit on this size. Please remove motif(s)
                    to select this size.
                </div>
            </div>
            <div class="overlay"
                 @click="
          alertWidthActive = false;
          alertWidthMotif = null;
        "></div>
        </div>
        <div class="overlay"></div>

            </div>


</template>

<script>
    import ProductPreview from "@/components/ProductPreview.vue";
    import CustomMotif from "@/components/CustomMotif.vue";
    import Finish from "@/components/Finish.vue";
    import Globals from "@/globals.js";
    export default {
        name: "Motifs",
        components: {
            ProductPreview,
            CustomMotif,
            Finish,
        },
        data() {
            return {
                customizingMotif: null,
                customizingProductMotif: null,
                popup: "",
                routeIndexNext: 1,
                routeIndexPrev: -1,
                routeDirection: "next",
                alertWidthActive: false,
                alertWidthMotif: null,
                leaveActive:false,
            };
        },
        watch: {
            $route(to, from) {
                

                let routes = this.$router.getRoutes();
                let fromRoute = routes.find((i) => i.name === from.name);
                let fromRouteIndex = routes.indexOf(fromRoute);

                let toRoute = routes.find((i) => i.name === to.name);
                let toRouteIndex = routes.indexOf(toRoute);

                this.routeDirection = fromRouteIndex < toRouteIndex ? "next" : "previous";
                this.$refs.app.setAttribute("data-route", toRoute.name);
                this.$nextTick(() => {
                    this.$store.dispatch("setLoadingStatus", "");

                });
               

            },
        },
        mounted: function () {
           // this.$refs.app.classList.add(this.$store.state.productInfo.productName.replace(' ', '-').toLowerCase());
            this.setInit();
        },
        updated: function () {

            this.setInit();
        },
        methods: {
            rootUrl() {
                return Globals.getRootUrl()
            },
            productLocation() {
                return Globals.getProductLocation()
            },
            setLoading() {
                return new Promise((resolve, reject) => {
                    let x = this.$store.dispatch("setLoadingStatus", "Loading");
                    setTimeout(() => {
                        return (x) ? resolve(this.$store.state.loadingStatus) : reject('error');
                    }, 200);
                });
            },
            goRoute(routeName) {

                //console.log(routeName);
                this.setLoading().then(value => {
                    //console.log('then');
                    this.$router.push(routeName);
                    //console.log(value);
                })
            },
            setInit() {
                this.$nextTick(() => {

                    // The whole view is rendered

                    let routes = this.$router.getRoutes();
                    let currentRoute = routes.find((i) => i.name === this.$route.name);
                    let currentRouteIndex = routes.indexOf(currentRoute);

                    this.routeIndexPrev =
                        currentRouteIndex == 0 ? -1 : currentRouteIndex - 1;
                    this.routeIndexNext =
                        currentRouteIndex == routes.length - 1 ? -1 : currentRouteIndex + 1;

                    let pGuid = new URL(location.href).searchParams.get("p");
                    let urlPrefix = "/";
                    if (pGuid != null) urlPrefix += "?p=" + pGuid;

                    
                });
            },
            addCustomMotif(m, mi) {
                this.$store.dispatch("addCustomMotifToProduct", {
                    motif: m,
                    motifInputs: mi,
                });
                this.resetCustomizingMotif();
            },
            editCustomMotif(opm, upm) {
                this.$store.dispatch("editCustomProductMotif", {
                    originalPm: opm,
                    updatedPm: upm,
                });
                this.resetCustomizingMotif();
            },
            openCustomMotif(m, pm = null) {
                this.customizingProductMotif = pm;
                this.customizingMotif = m;
            },
            openBackground() {
                this.popup = "background";
            },
            resetCustomizingMotif() {
                this.customizingMotif = null;
                this.customiziingProductMotif = null;
            },
            alertWidth(motif) {
                if (motif) {
                    this.alertWidthMotif = motif;
                    this.alertWidthActive = true;
                } else {
                    this.alertWidthActive = true;
                }
            },
        },
    };
</script>

<style>
html {
  height: 100%;
}
    body {
        height: 100%;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        background:#ffffff;
    }
    #about {display:none;}
    #app {
        display: flex;
        flex-flow: column;
        height: 100%;
    }
    #npHeader {
        background: url("https://www.needlepaint.com/images/bg-main.png") repeat;
        /*height: 5em;
      position:relative;
  */
        box-shadow: 0 3px 3px #463f3f5e;
        z-index: 101;
    }
#npHeader > div {
  display: flex;
  padding: 0.25em;
  flex-direction: row;
  max-width: 960px;
  margin: auto;
}

    #npHeader h2 {
        font-size: 1em;
        line-height: 2.25em;
        margin: 0 0 0 1em;
        color: #666;
    }
    #hdrNavLogoLink {
        cursor:pointer;
    }
#hdrNavLogoLink img {
  height: 2.25em;
  display:block;
}
header {
  /*box-shadow: 0 3px 3px rgba(74, 74, 74, 0.5), 0 -3px 3px rgba(74, 74, 74, 0.5);*/
  z-index: 2;
  overflow: hidden;
  flex: 0 0 auto;
}
.header-info {
  display: flex;
  justify-content: flex-end;
  flex: 1 0 auto;
  -moz-column-gap: 0.5em;
  column-gap: 0.5em;
  align-items: center;
}

.header-info > div {
  justify-content: center;
  flex: 0 0 auto;
}
    .header-info .button {
        padding: 0 1em;
        line-height: 2.25rem;
        height: 2.25rem;
    } /*
        .header-info .button {
            color: #fff;
            background: #288b7a;
            line-height: 2.5rem;
            text-transform: uppercase;
            font-weight: 300;
            font-size: .85em;
            text-decoration: none;
            cursor: pointer;
            border: none;
            display: inline-block;
            border-radius: 3px;
            padding: 0 1em;
        }*/
.header-info .price {
  /*! line-height: 2.5rem; */
  font-size: 1.5em;
}
.price {
  font-size: 1.75rem;
  color: #288b7a;
}
.price span {
  font-size: 0.5em;
}
.popup {
  z-index: 102;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.popup .close {
  top: 0.25em;
  right: 0.25em;
  position: absolute;
  text-align:center;
}
.popup .close::before {
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.8em;
  border-radius: 100%;
  cursor: pointer;
}
.popup .close::before {
  content: "\2716";
  display: block;
}
.popup .close:hover::before {
  background: #ccc;
  color: #fff;
}
.popup.alert {
  z-index: 106;
}
.popup.alert .popup-content {
  max-width: calc(100% - 4em);
  width: 20em;
}
.popup.alert img.motif {
  height: 2em;
  -ms-interpolation-mode: nearest-neighbor;
  image-rendering: -moz-crisp-edges;
  image-rendering: pixelated;
  filter: drop-shadow(1px 1px 1px #666);
}
    .popup .popup-content {
        position: absolute;
        top: 50%;
        background: #fff;
        box-shadow: 0.25em 0.25em 0.25em #66666680, 0 0 0.25em #666;
        border-radius: 0.1em;
        padding: 2em 1em;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 600px;
        max-height: 600px;
        overflow-x: auto;
        width:calc(100% - 2em);
    }
.popup .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(57, 57, 57, 0.8);
  z-index: -1;
}
    .loading .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
    }
    .loading #btnFinish {
        background: #ccc;
    }
    .nav-buttons,
    .form-buttons {
        display: flex;
        flex-direction: row;
        -moz-column-gap: 1em;
        column-gap: 1em;
        max-width: 340px;
    }
.form-buttons {
  margin: 1em auto 0;
}

button,
.button,
.nav-buttons a,
.form-buttons a {
  color: #fff;
  background: #288b7a;
  display: block;
  line-height: 2.5em;
  height: 2.5em;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 0.85em;
  text-decoration: none;
  cursor: pointer;
  border: none;
}
    .button.secondary {
        background: #c0d4d5;
        color: #288b7a;
    }
    .content-button {
        max-width:300px;
        margin:auto;
    }
    .form-buttons a {
        flex: 1 1 auto;
        width: 67%;
    }

.form-buttons a:first-child {
  width: 33%;
  background: #c0d4d5;
  color: #288b7a;
}
#nav {
  padding: 0.25em 0;
  flex: 0 0 auto;
}

.nav-buttons a:hover,
.form-buttons a:hover,
button:hover,
.button:hover {
  box-shadow: 0 3px 5px #46433f61;
}

#nav a {
  position: relative;
  width: 6em;
  display: inline-block;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.75em;
  color: #666;
  height: 2em;
}
#nav a:hover {
  color: rgb(40, 139, 122);
}

#nav a.router-link-exact-active {
  font-weight: bold;
}
#nav a.router-link-exact-active::after {
  background-color: #666;
}

#nav a::after {
  content: " ";
  height: 1em;
  width: 1em;
  border: solid 1px #666;
  position: absolute;
  border-radius: 100%;
  background-color: #fff;
  left: 50%;
  transform: translate(-50%, 50%);
  bottom: 0;
}
#nav a:hover::after {
  border: solid 2px #666;
}
#nav a::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #666;
  bottom: 0;
  left: -50%;
  z-index: -1;
  transform: translate(0, 50%);
}

#nav a:first-child::before {
  display: none;
}
h3 {
  font-size: 1em;
  margin: 1em 0 0.5em;
}
p {
  line-height: 1.5em;
  margin-bottom: 1em;
}
p.intro {
  font-size: 1.25em;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-fade-next-enter-active,
.slide-fade-previous-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-next-leave-active,
.slide-fade-previous-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-next-enter,
.slide-fade-next-leave-to {
  transform: translateX(-100%);
  /*opacity: 0;*/
}

.slide-fade-previous-enter,
.slide-fade-previous-leave-to {
  transform: translateX(100%);
  /*opacity: 0;*/
}

.step {
  /* height: 100%; */
  height: 100%;
  /* overflow-y: scroll; */
}
.step > div {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.step-static {
  margin: 0 0 1em;
  flex: 0 1 auto;
}
    .step-static .step-content,
    .step-scroll .step-content {
        max-width: 960px;
        margin: auto;
    }
.step-static h2 {
  text-transform: uppercase;
  margin: 0.5em 0;
  font-size: 1.25em;
}
.step-scroll h2 {
  text-transform: uppercase;
  margin: 0.5em 0 1.5em;
  font-size: 1em;
}
.step-scroll .info-box {
  background: #fff;
  border-radius: 1em;
  padding: 1em;
  margin: 3em 0.25em 1em;
  border: solid 1px #666;
}

.step-scroll .info-box p {
  line-height: 1.5em;
  margin: 1em auto;
  max-width: 600px;
}
.step-scroll {
  /* max-height: 100%; */
  flex: 1 1 auto;
  /* background: #cccccc; */
  padding: 1em;
  margin: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  /*-webkit-mask-image: linear-gradient(to bottom, black 90%, transparent 100%);
        mask-image: linear-gradient(to bottom, black 90%, transparent 100%);*/
}
:root {
  --scrollbarWidth: 0.5rem;
  --scrollbarBg: rgb(198 196 188 / 0.2);
  --scrollbarThumb: rgb(213, 210, 198);
}

.step-scroll {
  scrollbar-width: var(--scrollbarWidth);
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbarThumb) var(--scrollbarBg);
}

.step-scroll::-webkit-scrollbar {
  width: var(--scrollbarWidth);
}

.step-scroll::-webkit-scrollbar-track {
  background: var(--scrollbarBg);
  border-radius: 6px;
}

.step-scroll::-webkit-scrollbar-thumb {
  background-color: var(--scrollbarThumb);
  border-radius: 6px;
  border: 3px solid var(--scrollbarBg);
}

#stepContainer {
  height: calc(100vh);
  flex: 1 1 auto;
  overflow: hidden;
  /*background: url('/images/bg-main.png') repeat;*/
}

.key-fob .size-picker {
    display:none;
}

    .key-fob footer  {
        display: none;
    }

footer {
  flex: 0 1 auto;
  height: 4em;
  box-shadow: 0 -3px 8px rgba(74, 74, 74, 0.5);
  z-index: 2;
}

.select-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.select-list li {
  display: inline-block;
}

.slick-slider {
  max-width: calc(100% - 3em);
  margin: auto;
}
.slick-list {
  /*-webkit-mask-image: linear-gradient( 90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 5%, rgba(0,0,0,1) 95%, rgba(0,0,0,0) 100%);
        mask-image: linear-gradient( 90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 5%, rgba(0,0,0,1) 95%, rgba(0,0,0,0) 100%);*/
}
button.slick-arrow::before {
  color: #333;
}
.slick-prev {
  left: -1.5rem;
}
.slick-next {
  right: -1.5rem;
}
.slick-slide {
  cursor: pointer;
}
.slick-slide > div {
  margin: 0 6px;
}

.slick-list {
  margin: 0 0 0 -6px;
}

.select-background {
  position: absolute;
  right: 1em;
  top: 1em;
  display: block;
  text-decoration: underline;
  cursor: pointer;
}
    .loading-status.inactive {
        opacity: .1;
        color:#cc0000;
        /*pointer-events: none;
        transition: opacity 1s;*/
    }
        .loading-status {
            opacity: 1;
            pointer-events:none;
        }

    .loading-status.loaded {
        opacity: 0;
        transition: opacity 1s;
    }
</style>
